import Quill from "quill";

const Image = Quill.import("formats/image");

class CustomImage extends Image {
  static create(value) {
    const node = super.create(value.src);

    node.setAttribute("src", value.src);

    if (value.imageId) {
      node.setAttribute("data-image-id", value.imageId);
    }

    return node;
  }

  static value(node) {
    return {
      src: node.getAttribute("src"),
      imageId: node.getAttribute("data-image-id"),
    };
  }
}

CustomImage.blotName = "image";
CustomImage.tagName = "IMG";

Quill.register(CustomImage, true);
